export function setupTokenIsExpired(
  expiresAt: string | null,
  nowMilliseconds = Date.now(),
): boolean {
  if (expiresAt === null) return false;
  return Date.parse(expiresAt) <= nowMilliseconds;
}
